import { render } from "./auth.vue?vue&type=template&id=3351302e&scoped=true"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"

import "./auth.vue?vue&type=style&index=0&id=3351302e&scoped=true&lang=css"
import "./auth.vue?vue&type=style&index=1&id=3351302e&lang=scss&scoped=true"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3351302e"]])

export default __exports__